"use strict";

exports.__esModule = true;
exports.subscribeLiquidCrowdloanTokenPrice = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _storage = require("../../utils/storage");
var _operators = require("rxjs/operators");
const LEASE_BLOCK_NUMBERS = {
  13: 17856000
};

/*
  The LiquidCrowdloan token price is calculated by DOT oracle price and current relaychain block number
  formula: oracle price * (1 / (1 + rewardRate) ** (lease block number - current relaychain block))
*/
const getLiquidCrowdloanPrice = (api, lease, currentRelayBlockNumber, stakingCurrencyPrice) => {
  var _api$consts, _api$consts$prices, _api$consts$prices$re;
  const rewardRatePerRelaychainBlock = ((_api$consts = api.consts) === null || _api$consts === void 0 ? void 0 : (_api$consts$prices = _api$consts.prices) === null || _api$consts$prices === void 0 ? void 0 : (_api$consts$prices$re = _api$consts$prices.rewardRatePerRelaychainBlock) === null || _api$consts$prices$re === void 0 ? void 0 : _api$consts$prices$re.toNumber()) || 0;
  const leaseBlockNumber = LEASE_BLOCK_NUMBERS[lease];
  const discount = _sdkCore.FixedPointNumber.ONE.div(new _sdkCore.FixedPointNumber((1 + rewardRatePerRelaychainBlock / 10 ** 18) ** Math.max(leaseBlockNumber - currentRelayBlockNumber, 0)));
  return stakingCurrencyPrice.mul(discount);
};
const subscribeLiquidCrowdloanTokenPrice = (api, stakingTokenPrice, lease) => {
  const block$ = _storage.Storage.create({
    api: api,
    path: 'rpc.chain.getBlock',
    params: []
  }).observable;
  return block$.pipe((0, _operators.map)(block => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const extrinsic = block.block.extrinsics.find(item => {
      return item.method.section === 'parachainSystem' && item.method.method === 'setValidationData';
    });
    if (extrinsic) {
      var _args$validationData, _args$validationData$;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const args = extrinsic.method.args[0];
      const relayChainBlockNumber = args === null || args === void 0 ? void 0 : (_args$validationData = args.validationData) === null || _args$validationData === void 0 ? void 0 : (_args$validationData$ = _args$validationData.relayParentNumber) === null || _args$validationData$ === void 0 ? void 0 : _args$validationData$.toNumber();
      if (!LEASE_BLOCK_NUMBERS[lease]) return _sdkCore.FixedPointNumber.ZERO;
      return getLiquidCrowdloanPrice(api, lease, relayChainBlockNumber, stakingTokenPrice);
    }
    return _sdkCore.FixedPointNumber.ZERO;
  }));
};
exports.subscribeLiquidCrowdloanTokenPrice = subscribeLiquidCrowdloanTokenPrice;